import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { ExInput } from "../../extras/Input";
import Button from "../../extras/Button";
import { closeDialog } from "../../../redux/slice/dialogueSlice";
import { Box, Modal } from "@mui/material";

const CancleDetails = () => {
  const { dialogueData } = useSelector((state) => state.dialogue);
  const dispatch = useDispatch();
  const [mongoId, setMongoId] = useState("");

  useEffect(() => {
    if (dialogueData) {
      setMongoId(dialogueData);
    }
  }, [dialogueData]);

  return (
    <Modal
      open={true}
      onClose={closeDialog}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box className="model-style">

        <div className="model-header">
          <p className="m-0">Cancel Details</p>
        </div>

       <div className="model-body">
          <div className="row align-items-start formBody">
            <div className="col-12">
              <ExInput
                type={`text`}
                id={`reason`}
                name={`reason`}
                label={`Reason`}
                placeholder={`Reason`}
                value={mongoId?.cancel?.reason}
                disabled={true}
              />
            </div>
            <div className="col-12">
              <ExInput
                type={`text`}
                id={`Date`}
                name={`Date`}
                label={`Date`}
                placeholder={`Date`}
                value={mongoId?.cancel?.date}
                disabled={true}
              />
            </div>
            <div className="col-12">
              <ExInput
                type={`text`}
                id={`Time`}
                name={`Time`}
                label={`Time`}
                placeholder={`Time`}
                value={mongoId?.cancel?.time}
                disabled={true}
              />
            </div>
          </div>
         </div>
         <div className="model-footer">
           <div className="m-3 d-flex justify-content-end gap-2">
              <Button
                 className={`close-model-btn`}
                text={`Cancel`}
                type={`button`}
                onClick={() => dispatch(closeDialog())}
              />
           </div>
            
          </div>
       

      </Box>
    </Modal>

  );
};
export default CancleDetails;
